
export const  API_OK=200;
export const  API_SC_FAIL=999;


export const Code_list_SupplierAnnouncementCatalog = 'SupplierAnnouncementCatalog'
export const Code_list_CourseCatalog = 'CourseCatalog'
export const Code_list_CourseTarget = 'CourseTarget'


export const DS_UserManual= {
    '01Profile & Visiting': [
        "01Profile",
        "02Visiting"
    ],
    '02Procurement': [
        "01Genernal",
        "02Planning",
        "03Purchasing",
        "04Delivery",
        "05Invoice",
    ],
    "03Engineering":["01Quality","02eRepair"],
    "04Sustainability Management":["None"],
    "05Resources & Help":["None"],
}

export const DS_SUPPLIER_ROLE=[
    // "All",
    "Sales",
    "Sales_Head",
    "QC",
    "QC_Head",
    "Technical",
    "Technical_Head",
    "Executive",
    "Planning",
    "Purchasing",
    "Accounting",
    "Logistic",
    "ESH",
    "Other",
]

export const DS_SUPPLIER_CATALOG=[
    "Accessory",
    "AMHS",
    "Direct_Material",
    "EDA/IP",
    "Equipment",
    "Facility",
    "General_Affairs",
    "Indirect_Material",
    "IT",
    "Spare_Parts",
    "other",
]

export const DS_SUPPLIER_GROUP_TYPE_1_TYPE="1"
export const DS_SUPPLIER_GROUP_TYPE_2_CSV="2"

export const DS_SUPPLIER_GROUP_TYPE=[
    {id:"1",text:"類別"},
    {id:"2",text:"CSV"},
]




export const COURSE_FMT_TYPE_CousrsePkg="1"
export const COURSE_FMT_TYPE_Video="2"
export const COURSE_FMT_TYPE_doc="3"

export const Course_File_Type1_File ="1";
export const Course_File_Type2_Link ="2";


export const DS_COURSE_FMT_TYPE=[
    {id:"1",text:"課程包"},
    {id:"2",text:"影片"},
    {id:"3",text:"文件"},
]
export const DS_YES_NO=[
    "是",
    "否",
]
export const DS_ENABLE_DISABLE=[
    "啟用",
    "停用",
]

export const TableName_CODE_LIST="CODE_LIST";
export const TableName_COURSE="COURSE";
export const TableName_COURSE_INVITE_EMPLOYEE="COURSE_INVITE_EMPLOYEE";
export const TableName_COURSE_INVITE_SUPPLIER_GUEST="COURSE_INVITE_SUPPLIER_GUEST";
export const TableName_COURSE_MISSION_ALLOC="COURSE_MISSION_ALLOC";
export const TableName_COURSE_MISSION_ALLOC_GROUPS="COURSE_MISSION_ALLOC_GROUPS";
export const TableName_COURSE_MISSION_ALLOC_REL_GROUP="COURSE_MISSION_ALLOC_REL_GROUP";
export const TableName_COURSE_MISSION_ALLOC_REL_SUPPLIER="COURSE_MISSION_ALLOC_REL_SUPPLIER";
export const TableName_COURSE_MISSION_ALLOC_RESULT="COURSE_MISSION_ALLOC_RESULT";
export const TableName_COURSE_MISSION_ALLOC_SUPPLIERS="COURSE_MISSION_ALLOC_SUPPLIERS";
export const TableName_COURSE_QUIZE="COURSE_QUIZE";
export const TableName_COURSE_TOPIC="COURSE_TOPIC";
export const TableName_GRIEVANCE="GRIEVANCE";
export const TableName_hibernate_sequence="hibernate_sequence";
export const TableName_SPRING_SESSION="SPRING_SESSION";
export const TableName_SPRING_SESSION_ATTRIBUTES="SPRING_SESSION_ATTRIBUTES";
export const TableName_SUPPLIER="SUPPLIER";
export const TableName_SUPPLIER_ANNOUNCEMENT="SUPPLIER_ANNOUNCEMENT";
export const TableName_SUPPLIER_GROUP="SUPPLIER_GROUP";
export const TableName_SUPPLIER_GROUP_REL_SUPPLIER="SUPPLIER_GROUP_REL_SUPPLIER";
export const TableName_SUPPLIER_GROUP_SUPPLIERS="SUPPLIER_GROUP_SUPPLIERS";
export const TableName_SUPPLIER_GUEST="SUPPLIER_GUEST";
export const TableName_SUPPLIER_GUEST_REL_SUPPLIER="SUPPLIER_GUEST_REL_SUPPLIER";
export const TableName_SUPPLIER_GUEST_SUPPLIERS="SUPPLIER_GUEST_SUPPLIERS";
export const TableName_SUPPLIER_REQUIREMENT="SUPPLIER_REQUIREMENT";
export const TableName_UPLOAD_FILE="UPLOAD_FILE";
export const TableName_USER_MANUAL="USER_MANUAL";



export const  UploadFile_Type_UserManualC_M="UploadFile_Type_UserManualC_M";
export const  UploadFile_Type_UserManualE_M="UploadFile_Type_UserManualE_M";

export const  UploadFile_Type_SupplierAnnoC_S="UploadFile_Type_SupplierAnnoC_S";
export const  UploadFile_Type_SupplierAnnoE_S="UploadFile_Type_SupplierAnnoE_S";
export const  UploadFile_Type_SupplierAnno_Image_S="UploadFile_Type_SupplierAnno_Image_S";

export const  UploadFile_Type_SupplierReqC_S="UploadFile_Type_SupplierReqC_S";
export const  UploadFile_Type_SupplierReqM_S="UploadFile_Type_SupplierReqE_S";



export const  UploadFile_Type_Course_Image_S="UploadFile_Type_Course_Image_S";

export const  UploadFile_Type_Course_TextbookC_M="UploadFile_Type_Course_TextbookC_M";
export const  UploadFile_Type_Course_TextbookE_M="UploadFile_Type_Course_TextbookE_M";

export const  UploadFile_Type_Course_DocC_M="UploadFile_Type_Course_DocC_M";
export const  UploadFile_Type_Course_DocE_M="UploadFile_Type_Course_DocE_M";

export const  UploadFile_Type_GrievanceFile_S="UploadFile_Type_GrievanceFile_S";

export const  UploadFile_Type_Declaration_M="UploadFile_Type_Declaration_M";
export const  UploadFile_Type_SupplierGroup_S="UploadFile_Type_SupplierGroup_S";

export const FileUpload_acceptedFiles_image=".jpeg,.jpg,.png,.gif";

export const FileUpload_acceptedFiles_pdf=".pdf";


export const LoginUserIdCookieName="LD_MAP";
export const LoginUserTypeCookieName="LT_MAP";

export const LoginUserType1_Api="1";
export const LoginUserType2_Guest="2";

export const Declaration_MaxUploadFileCount=5;

export const GridPagination={
    rowsPerPage:10
}

export const GridFooterProps={
    'items-per-page-options': [10,15, 30, 50, 100]
}


export const GPK_Type1_Sales="sales";
export const GPK_Type2_Purchase="purchase";
export const GPK_Type3_Cashflow="cashflow";
// export const GPK_Type3_PerfTarget="perfTarget";
export const GPK_Type5_ExchangeRate="exchangeRate";
export const GPK_Type6_SalesPerformance="salesPerformance";

export const GPK_ReportType1_business="business";
export const GPK_ReportType2_cashflow="cashflow";


export const  GPK_BatchJob_Type_busreport = "busreport";
export const  GPK_BatchJob_Type_cashflow = "cashflow";


export const GPK_Type8_Customer = "customer";
export const GPK_Type9_Supplier = "supplier";
export const GPK_Type101_Quotation_Project = "quotation_project";
export const GPK_Type10_Quotation_Contract = "quotation_contract";
export const GPK_Type11_Quotation_Equ = "quotation_equ";
export const GPK_Type12_Quotation_Part = "quotation_part";
export const GPK_Type13_Quotation_Job = "quotation_job";
export const GPK_Type14_QuotationCal_Project = "quotationCal_project";
export const GPK_Type15_QuotationCal_NotProject = "quotationCal_notProject";
export const GPK_Type16_QuotationCal_Project_PartImport = "quotationCal_project_partImport";
export const GPK_Type17_QuotationCal_Project_PartInternal = "quotationCal_project_partInternal";
export const GPK_Type18_QuotationCal_Project_Job = "quotationCal_project_job";
export const GPK_Type19_CostAnaly = "costAnaly";

export const GPK_Field_equ_設備種類="設備種類"
export const GPK_Field_part_零件類別="零件類別"
export const GPK_Field_job_施工類別="施工類別"

export const GPK_Field_PumpItemNo ="PumpItemNo"
export const GPK_Field_零件幣別 ="零件幣別"

export const GPK_Type20_Test = "test";

export const UserDB_UBoss=[

    ]
export const UserDB=[
    {
        LoginId:"shouldbio.taipei",
        Pwd:"shouldbio123",
        Role:['GPK1','GPK2','FECN','FECM','GPW','OLD']
        // Role:['GPK1']
    },
    {
        LoginId:"UBOSS",
        Pwd:"UBOSS8888",
        Role:['GPK1','GPK2','FECN','FECM','GPW','OLD']
        // Role:['GPK1']
    },
    {
        LoginId:"52819214",
        Pwd:"52819214",
        Role:['GPK1','GPK2','FECN','FECM','GPW','OLD']
        // Role:['GPK1']
    },
    {
        LoginId:"52857997",
        Pwd:"52857997",
        Role:['GPK1','GPK2','FECN','FECM','GPW','OLD']
        // Role:['GPK1']
    },
    {
        LoginId:"83177290",
        Pwd:"83177290",
        Role:['GPK1','GPK2','FECN','FECM','GPW','OLD']
        // Role:['GPK1']
    },
    {
        LoginId:'ADMIN',
        Pwd:'AdminGPK',
        Role:['FEC1','FEC2','GPW','PJT','GPK1','GPK2','FECM'],
        RoleCashFlow:['FEC1','FEC2','FEC','GPW','PJT','PRO','GPK1','GPK2','GPK'],
        Permission:['ADMIN','FunInputSales','FunInputPurchase','FunInputRate','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
        PivoteDep:['FEC1','FEC2','GPW','PJT','GPK1','GPK2','FECM'],
        PivoteDeleteSheet:[],
        BusReportVType:"BR_VSTD",
    },
    {
        LoginId:'LUCY',
        Pwd:'LucyGPK',
        Role:['FEC1','FEC2','GPW','PJT','GPK1','GPK2','FECM'],
        RoleCashFlow:['FEC1','FEC2','FEC','GPW','PJT','PRO','GPK1','GPK2','GPK'],
        Permission:['FunInputSales','FunInputPurchase','FunInputRate','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
        PivoteDep:['FEC1','FEC2','GPW','PJT','GPK1','GPK2','FECM'],
        PivoteDeleteSheet:[],
        BusReportVType:"BR_VSTD",
    },
    {
        LoginId:'DOREEN',
        Pwd:'DoreenGPK',
        Role:['PJT','GPK1','GPK2','FEC1','FEC2'],
        RoleCashFlow:[],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
        PivoteDep:['PJT','GPK1','GPK2','FEC1','FEC2'],
        PivoteDeleteSheet:['業務目標_高治','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V1",
    },
    {
        LoginId:'EVONNE',
        Pwd:'EvonneGPK',
        Role:['FEC1','FEC2','GPK2'],
        RoleCashFlow:[],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
        PivoteDep:['FEC1','FEC2','GPK2'],
        PivoteDeleteSheet:['異常訊息_AE進度','業務目標_高治','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V2",
    },
    {
        LoginId:'GRACE',
        Pwd:'GraceGPK',
        Role:['FEC1','FEC2','FECM'],
        RoleCashFlow:[],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
        PivoteDep:['FEC1','FEC2','FECM'],
        PivoteDeleteSheet:['異常訊息_AE進度','業務目標_高治','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V2",
    },
    {
        LoginId:'DEBBY',
        Pwd:'DebbyGPK',
        Role:['GPW'],
        RoleCashFlow:[],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
        PivoteDep:['GPW'],
        PivoteDeleteSheet:['異常訊息_AE進度','業務各月表現','產品業績&毛利','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V1",
    },
    {
        LoginId:'EDDIE',
        Pwd:'EddieGPK',
        Role:['FEC1','FEC2','GPW','PJT','GPK1','GPK2','FECM'],
        RoleCashFlow:['GPK1','GPK2','GPK','FECN','FECM','FEC','GPW'],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
        PivoteDep:['FEC1','FEC2','GPW','PJT','GPK1','GPK2','FECM'],
        PivoteDeleteSheet:[],
        BusReportVType:"BR_VSTD",
    },
    {
        LoginId:'MAX',
        Pwd:'MaxGPK',
        Role:['FEC1','FEC2','GPK1','GPK2','FECM'],
        RoleCashFlow:['GPK1','GPK2','GPK','FECN','FECM','FEC'],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
        PivoteDep:['FEC1','FEC2','GPK1','GPK2','FECM'],
        PivoteDeleteSheet:['業務目標_高治','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V2",
    },
    {
        LoginId:'ERIC',
        Pwd:'EricGPK',
        Role:['PJT','GPK1'],
        RoleCashFlow:['PJT','GPK1'],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
        PivoteDep:['PJT','GPK1'],
        PivoteDeleteSheet:['業務目標_高治','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V1",
    },
    {
        LoginId:'RAY',
        Pwd:'RayGPK',
        Role:['FEC1','FEC2','GPK2'],
        RoleCashFlow:['FEC2','GPK2'],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
        PivoteDep:['FEC1','FEC2','GPK2'],
        PivoteDeleteSheet:['異常訊息_AE進度','業務目標_高治','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V2",
    },
    {
        LoginId:'DANIEL',
        Pwd:'DanielGPK',
        Role:['GPW',' PJT'],
        RoleCashFlow:['GPW',' PJT','PRO'],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
        PivoteDep:['GPW',' PJT'],
        PivoteDeleteSheet:['異常訊息_AE進度','異常訊息_客戶交貨進度','異常訊息_供應商交貨','異常訊息_收款','異常訊息_毛利率','業績細部狀況','預估發票結案1','預估發票結案2','業務各月表現','產品業績&毛利','異常售服統計','庫存統計','應收案統計','應付案統計','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V1",
    },
    {
        LoginId:'CHARLIE',
        Pwd:'CharlieGPK',
        Role:['GPW',' PJT'],
        RoleCashFlow:['GPW',' PJT'],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
        PivoteDep:['GPW',' PJT'],
        PivoteDeleteSheet:['異常訊息_AE進度','異常訊息_客戶交貨進度','異常訊息_供應商交貨','異常訊息_收款','異常訊息_毛利率','業績細部狀況','預估發票結案1','預估發票結案2','業務各月表現','產品業績&毛利','異常售服統計','庫存統計','應收案統計','應付案統計','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V1",
    },
    {
        LoginId:'LOUIS',
        Pwd:'LouisGPK',
        Role:['GPW'],
        RoleCashFlow:[],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
        PivoteDep:['GPW'],
        PivoteDeleteSheet:['異常訊息_AE進度','異常訊息_客戶交貨進度','異常訊息_供應商交貨','異常訊息_收款','異常訊息_毛利率','業績細部狀況','預估發票結案1','預估發票結案2','業務各月表現','產品業績&毛利','異常售服統計','庫存統計','應收案統計','應付案統計','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V1",
    },
    {
        LoginId:'TONY',
        Pwd:'TonyGPK',
        Role:[],
        RoleCashFlow:['GPW'],
        Permission:['FunInputTarget','FunReportCetner','FunReportPivote2','FunReportPivote3'],
        PivoteDep:['GPW'],
        PivoteDeleteSheet:['異常訊息_AE進度','異常訊息_客戶交貨進度','異常訊息_供應商交貨','異常訊息_收款','異常訊息_毛利率','業績細部狀況','預估發票結案1','預估發票結案2','業務各月表現','產品業績&毛利','異常售服統計','庫存統計','應收案統計','應付案統計','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V1",
    },
    {
        LoginId:'PETER',
        Pwd:'PeterGPK',
        Role:['GPW'],
        RoleCashFlow:[],
        Permission:['FunInputTarget','FunReportCetner','FunReportPivote2','FunReportPivote3'],
        PivoteDep:['GPW'],
        PivoteDeleteSheet:['異常訊息_AE進度','異常訊息_客戶交貨進度','異常訊息_供應商交貨','異常訊息_收款','異常訊息_毛利率','業績細部狀況','預估發票結案1','預估發票結案2','業務各月表現','產品業績&毛利','異常售服統計','庫存統計','應收案統計','應付案統計','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V1",
    },
    {
        LoginId:'MONICA',
        Pwd:'MonicaGPK',
        Role:[],
        RoleCashFlow:[],
        Permission:['FunInputRate'],
        PivoteDep:[],
        PivoteDeleteSheet:[],
        BusReportVType:"BR_VSTD",
    },
    {
        LoginId:'CEDRIC',
        Pwd:'CedricGPK',
        Role:['FEC1'],
        RoleCashFlow:['FEC1'],
        Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
        PivoteDep:['FEC1'],
        PivoteDeleteSheet:['異常訊息_AE進度','業務目標_高治','各案件採購進度查詢表','新增成交案'],
        BusReportVType:"BR_V2",
    },
    //---------old-----------
    // {
    //     LoginId:'Admin',
    //     Pwd:'AdminGPK',
    //     Role:['FEC1','FEC2','GPW','PJT','GPK1','GPK2','FECM'],
    //     RoleCashFlow:['FEC1','FEC2','FEC','GPW','PJT','PRO','GPK1','GPK2','GPK'],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputRate','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
    // },
    // {
    //     LoginId:'Lucy',
    //     Pwd:'LucyGPK',
    //     Role:['FEC1','FEC2','GPW','PJT','GPK1','GPK2','FECM'],
    //     RoleCashFlow:['FEC1','FEC2','FEC','GPW','PJT','PRO','GPK1','GPK2','GPK'],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputRate','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
    // },
    // {
    //     LoginId:'Doreen',
    //     Pwd:'DoreenGPK',
    //     Role:['PJT','GPK1','GPK2','FEC1','FEC2'],
    //     RoleCashFlow:[],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
    // },
    // {
    //     LoginId:'Evonne',
    //     Pwd:'EvonneGPK',
    //     Role:['FEC1','FEC2','GPK2'],
    //     RoleCashFlow:[],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
    // },
    // {
    //     LoginId:'Grace',
    //     Pwd:'GraceGPK',
    //     Role:['FEC1','FEC2','FECM'],
    //     RoleCashFlow:[],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
    // },
    // {
    //     LoginId:'Debby',
    //     Pwd:'DebbyGPK',
    //     Role:['GPW'],
    //     RoleCashFlow:[],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
    // },
    // {
    //     LoginId:'Eddie',
    //     Pwd:'EddieGPK',
    //     Role:['FEC1','FEC2','GPW','PJT','GPK1','GPK2','FECM'],
    //     RoleCashFlow:['GPK1','GPK2','GPK','FECN','FECM','FEC','GPW'],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
    // },
    // {
    //     LoginId:'Max',
    //     Pwd:'MaxGPK',
    //     Role:['FEC1','FEC2','GPK1','GPK2','FECM'],
    //     RoleCashFlow:['GPK1','GPK2','GPK','FECN','FECM','FEC'],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
    // },
    // {
    //     LoginId:'Eric',
    //     Pwd:'EricGPK',
    //     Role:['PJT','GPK1'],
    //     RoleCashFlow:['PJT','GPK1'],
    //     Permission:['FunInputTarget','FunReportCetner','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
    // },
    // {
    //     LoginId:'Ray',
    //     Pwd:'RayGPK',
    //     Role:['FEC1','FEC2','GPK2'],
    //     RoleCashFlow:['FEC2','GPK2'],
    //     Permission:['FunInputTarget','FunReportCetner','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
    // },
    // {
    //     LoginId:'Daniel',
    //     Pwd:'DanielGPK',
    //     Role:['GPW',' PJT'],
    //     RoleCashFlow:['GPW',' PJT','PRO'],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
    // },
    // {
    //     LoginId:'Charlie',
    //     Pwd:'CharlieGPK',
    //     Role:['GPW',' PJT'],
    //     RoleCashFlow:['GPW',' PJT'],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote1','FunReportPivote2','FunReportPivote3','FunInputCashflow'],
    // },
    // {
    //     LoginId:'Louis',
    //     Pwd:'LouisGPK',
    //     Role:['GPW',' PJT'],
    //     RoleCashFlow:[],
    //     Permission:['FunInputTarget','FunReportCetner','FunReportPivote1','FunReportPivote2','FunReportPivote3'],
    // },
    // {
    //     LoginId:'Tony',
    //     Pwd:'TonyGPK',
    //     Role:[],
    //     RoleCashFlow:['GPW'],
    //     Permission:['FunInputTarget','FunReportCetner','FunReportPivote2','FunReportPivote3'],
    // },
    // {
    //     LoginId:'Peter',
    //     Pwd:'PeterGPK',
    //     Role:['GPW'],
    //     RoleCashFlow:[],
    //     Permission:['FunInputTarget','FunReportCetner','FunReportPivote2','FunReportPivote3'],
    // },
    // {
    //     LoginId:'Monica',
    //     Pwd:'MonicaGPK',
    //     Role:[],
    //     RoleCashFlow:[],
    //     Permission:['FunInputRate'],
    // },
    // // Old
    // {
    //     LoginId:'ADMIN',
    //     Pwd:'ADMINGPK',
    //     Role:['GPK1','GPK2','FECN','FECM','GPW'],
    //     Permission:['FunInputCashflow','ADMIN','FunInputSales','FunInputPurchase','FunInputRate','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPK1','FieldGPK2','FieldFECN','FieldFECM','FieldGPWType','FieldGPWArea','FieldGPW'],
    // },
    //
    //
    // {
    //     LoginId:'LUCY',
    //     Pwd:'LUCYGPK',
    //     Role:['GPK1','GPK2','FECN','FECM','GPW'],
    //     Permission:['FunInputCashflow','FunInputSales','FunInputPurchase','FunInputRate','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPK1','FieldGPK2','FieldFECN','FieldFECM','FieldGPWType','FieldGPWArea','FieldGPW'],
    // },
    //
    //
    // {
    //     LoginId:'DOREEN',
    //     Pwd:'DOREENGPK',
    //     Role:['GPK1','GPK2','FECN','FECM'],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPK1','FieldGPK2','FieldFECN','FieldFECM'],
    //     PivoteDep:['GPK1','GPK2','FECN','FECM','GPW'],
    //     PivoteDeleteSheet:['業務目標_高治','各案件採購進度查詢表','新增成交案'],
    // },
    //
    //
    // {
    //     LoginId:'EVONNE',
    //     Pwd:'EVONNEGPK',
    //     Role:['GPK2'],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPK2'],
    //     PivoteDep:['GPK2'],
    //     PivoteDeleteSheet:['異常訊息_AE進度','業務目標_高治','各案件採購進度查詢表','新增成交案'],
    // },
    //
    //
    // {
    //     LoginId:'GRACE',
    //     Pwd:'GRACEGPK',
    //     Role:['FECN','FECM'],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldFECN','FieldFECM'],
    //     PivoteDep:['FECN','FECM'],
    //     PivoteDeleteSheet:['異常訊息_AE進度','業務目標_高治','各案件採購進度查詢表','新增成交案'],
    // },
    //
    //
    // {
    //     LoginId:'DEBBY',
    //     Pwd:'DEBBYGPK',
    //     Role:['GPW'],
    //     Permission:['FunInputSales','FunInputPurchase','FunInputTarget','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPWType','FieldGPWArea','FieldGPW'],
    //     PivoteDep:['GPW'],
    //     PivoteDeleteSheet:['異常訊息_AE進度','業務各月表現','產品業績&毛利','各案件採購進度查詢表','新增成交案'],
    // },
    //
    //
    // {
    //     LoginId:'EDDIE',
    //     Pwd:'EDDIEGPK',
    //     Role:['GPK1','GPK2','FECN','FECM','GPW'],
    //     Permission:['FunInputCashflow','FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPK1','FieldGPK2','FieldFECN','FieldFECM','FieldGPWType','FieldGPWArea','FieldGPW'],
    // },
    //
    //
    // {
    //     LoginId:'MAX',
    //     Pwd:'MAXGPK',
    //     Role:['GPK1','GPK2','FECN','FECM'],
    //     Permission:['FunInputCashflow','FunInputSales','FunInputPurchase','FunInputTarget','FunReportCetner','FunReportCash','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPK1','FieldGPK2','FieldFECN','FieldFECM'],
    //     PivoteDep:['GPK1','GPK2','FECN','FECM','GPW'],
    //     PivoteDeleteSheet:['業務目標_高治','各案件採購進度查詢表','新增成交案'],
    // },
    //
    //
    // {
    //     LoginId:'ERIC',
    //     Pwd:'ERICGPK',
    //     Role:['GPK1'],
    //     Permission:['FunReportCetner','FunInputTarget','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPK1'],
    //     PivoteDep:['GPK1'],
    //     PivoteDeleteSheet:['業務目標_高治','各案件採購進度查詢表','新增成交案'],
    // },
    //
    //
    // {
    //     LoginId:'RAY',
    //     Pwd:'RAYGPK',
    //     Role:['GPK2'],
    //     Permission:['FunReportCetner','FunInputTarget','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPK2'],
    //     PivoteDep:['GPK2'],
    //     PivoteDeleteSheet:['異常訊息_AE進度','業務目標_高治','各案件採購進度查詢表','新增成交案'],
    // },
    //
    //
    // {
    //     LoginId:'DANIEL',
    //     Pwd:'DANIELGPK',
    //     Role:['GPW'],
    //     Permission:['FunInputCashflow','FunInputTarget','FunInputSales','FunInputPurchase','FunReportCetner','FunReportCash','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPWType','FieldGPWArea','FieldGPW'],
    //     PivoteDep:['GPW'],
    //     PivoteDeleteSheet:['異常訊息_AE進度','異常訊息_客戶交貨進度','異常訊息_供應商交貨','異常訊息_收款','異常訊息_毛利率','業績細部狀況','預估發票結案1','預估發票結案2','業務各月表現','產品業績&毛利','異常售服統計','庫存統計','應收案統計','應付案統計','各案件採購進度查詢表','新增成交案'],
    // },
    //
    //
    // {
    //     LoginId:'CHARLIE',
    //     Pwd:'CHARLIEGPK',
    //     Role:['GPW'],
    //     Permission:['FunInputCashflow','FunInputTarget','FunInputSales','FunInputPurchase','FunReportCetner','FunReportCash','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPWType','FieldGPWArea','FieldGPW'],
    //     PivoteDep:['GPW'],
    //     PivoteDeleteSheet:['異常訊息_AE進度','異常訊息_客戶交貨進度','異常訊息_供應商交貨','異常訊息_收款','異常訊息_毛利率','業績細部狀況','預估發票結案1','預估發票結案2','業務各月表現','產品業績&毛利','異常售服統計','庫存統計','應收案統計','應付案統計','各案件採購進度查詢表','新增成交案'],
    // },
    //
    //
    // {
    //     LoginId:'LOUIS',
    //     Pwd:'LOUISGPK',
    //     Role:['GPW'],
    //     Permission:['FunReportCetner','FunInputTarget','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPWType','FieldGPWArea','FieldGPW'],
    // },
    //
    //
    // {
    //     LoginId:'TONY',
    //     Pwd:'TONYGPK',
    //     Role:['GPW'],
    //     Permission:['FunReportCetner','FunInputTarget','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPWType','FieldGPWArea','FieldGPW'],
    // },
    //
    //
    // {
    //     LoginId:'PETER',
    //     Pwd:'PETERGPK',
    //     Role:['GPW'],
    //     Permission:['FunReportCetner','FunInputTarget','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPWType','FieldGPWArea','FieldGPW'],
    // },
    //
    //
    // {
    //     LoginId:'MONICA',
    //     Pwd:'MONICAGPK',
    //     Role:[],
    //     Permission:['FunInputRate','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldGPWType','FieldGPWArea','FieldGPW'],
    // },
    //
    // {
    //     LoginId:'CEDRIC',
    //     Pwd:'CEDRICGPK',
    //     Role:['FECN','FECM'],
    //     Permission:['FunReportCetner','FunInputTarget','FunReportPivote','FieldDep','FieldSalesYear','FieldSalesMonth','FieldProjectType','FieldFECN','FieldFECM'],
    //     PivoteDep:['FECN','FECM'],
    //     PivoteDeleteSheet:['異常訊息_AE進度','業務目標_高治','各案件採購進度查詢表','新增成交案'],
    // },

];

// export let Customer_GPK1=["CTCI越南","FCFC NINGBO","FCFC SM3","FCFC 麥寮ARO1","FCFC麥寮ARO2","FCFC麥寮PC廠","FCFC麥寮SM","FCFC麥寮SM1","FCFC麥寮SM3","FCFC新港","FCFC寧波","FCFC寧波PTA6","FPCC","FPCC桃園儲運站","FPCC麥寮","FPCC麥寮公用廠","FPCC麥寮麥電公用二廠","FPCC麥寮煉一廠CDU#2","FPCC麥寮煉一廠CDU#3","FPCC麥寮煉油部","FPC仁武","FPC林園IPA","FPC高雄洲際碼頭","FPC麥寮HDPE","FPC寧波PDH","LOYAL MOTION越南","NAN YA EG USA","NAN YA EG USA TX","NAN YA 寧波BPA","NAN YA 寧波DOP","NAN YA仁武","NAN YA林口","NAN YA麥寮DOP","NAN YA麥寮EPOXY","NAN YA麥寮可塑劑","NAN YA新港銅箔","NAN YA寧波","STOCK","WISON (NAN YA TX EG)","上海高德","上鼎機械桃機航務處","大連","大連大社","大連大發","大連麥寮BDO2","大連彰濱","中石化大社","中油台中港","中油林園","中油桃煉","中油溪州","中油嘉義溶劑","中鼎","台塑出光","台塑越南河靜煤化工","台橡大社","台灣石化合成","本峰 (中油台中港)","百達精密","百達精密崙尾廠","李長榮化工林園","亞東石化","奇美","東聯","長春","長春苗栗","長春苗栗PVA OSBL","長春麥寮","長春彰濱","高治","麥寮汽電","華城電機","新能化工(大甲)","鈺德","寧波聯發"]
// export let Customer_GPK2=["FCFC","FCFC NINGBO","FCFC寧波ABS","FPC","FPCC","FPC寧波","FPC碳纖仁武","LCY","NAN YA","NAN YA崑山","NIPPON PAINT","NIPPON PAINT(菲律賓)","力麗","三井松","大東樹脂","大洋塑膠","大連","大連大發","大連麥寮","大園汽電","大儀","中台興","中石化大社","中油","中油大林","中油林園","中油桃煉","中油潤滑油事業部","中鈞","中興紡織","中鋼鋁業","中聯油脂","中聯資源","中纖","友輝","天晨","日勝化工","北誼興業(通霄)","北誼興業(樹林)","北誼興業樹林","台南紡織","台玻","台苯","台朔重工","台塑旭","台塑科騰","台達","台電明潭電廠","台電核三","台橡","台灣必成","台灣伊格爾","台灣汽電共生","台灣科慕","台灣索里思","台灣醋酸","正隆竹北","永豐餘新屋","立陞","立堃","交通大學機械所","华亿机电工程有限公司","合盛","安沃力士","年興","有麒","百達精密","羊基","李長榮大社","亞洲鼎禎","亞翔","京和","和協","奇美","尚承","承進","承進(中油林園)","旺嶸","昇威","明潭發電廠","明澤","東南國際","欣錩","采樾","金利行","金車","長春","長春人造樹脂","長春苗栗","長興","信銘","冠賜","南亞崑山","昱威(中油大林)","洋基工程","美商埃克森","英格索蘭","迪愛禧佳龍","埃克森美孚","展頌","神磊","神磊(興達發電廠)","高治","高治 (台灣汽電共生)","高治(EG)","高治(NAN YA EG)","高治(中石化)","高治(台合)","高治(申豐)","高治(和協)","高治(奇美)","高治(東聯)","高治(華夏)","高治(新桃電廠)","高泰","乾豐","偉普","健生","國亨","國基冷凍","國喬","清大","清華大學","統地","連結","陳業","勝合科技","富泰華(成虹)","復華機電","琮貿","華立","華亞汽電觀音","華夏海灣","華富","華陽電廠","開創","新益機械","新崙","群鴻","萬隆興","鈺德","鈺德(FPCC)","團霖","漢力能源","精翊機械","遠東新世紀","億崴","廣承","磐亞","璟儀","興社","環球橡膠","環鑫","聯新","鍾誠","豐興","羅門哈斯","關西塗料","鵬隆","耀群","鑫昌"]
// export let Customer_FECN=["AMPLE","CCD","CEDC","FHI","GBP菲律賓","GRANDE","LIANFA","LM","LMES","LOYAL-TEC","PHONG LE","SIEU HUYEN","TEH CHENG","一森","七福工業","九合工程","九如行","九邑","九品","九德松益","九譽","力方","力洪","力泰","力暉","力積電","力翰","力鵬","力麗","十友","三宏","三協豐","三和","三軍","三群","三嘉","三福化工","上化","上友","上林電機","上河國際","上淵","上喨","久大","久和醫療","久鈞","也順","千涵","千業","士昇","士林化技","士林紙業","大川","大中機械","大井","大允","大地酒店","大地興","大宇","大有環保","大自在","大宗","大欣","大城","大洋","大倚","大展","大桂","大將作","大康","大連","大陸工程","大陸水工","大喜","大儀","大德","大慶行","大穎","大營","大鑫","寸金","小人國","山林水","山洋","川久","川玖","工研院","中一","中化合成","中央大學","中央廣播","中石化小港","中石化頭份","中宇","中油桃煉","中油煉製","中油潤滑油","中南水電","中城","中政","中柱","中美和","中美和高雄","中國石油","中國鋼鐵","中華食品","中華紙漿","中軸","中鈞","中傳","中塑油品","中鼎","中德","中興傑達","中興電工","中鋼鋁業","中鋼機械","中龍","中聯油脂","中聯資源","中纖","丰元","五合","井盛","井新","井寶","仁吉","仁峰","今兵","介興","介鴻","允辰","元台","元利","元翎","元莆","公視","公準精密","六象","升振","及普","友正","友亦","友和","友俊","友誠","友達光電","友達桃園","友達環保","友德","友豐","天保","天泉","天倚","天祥","太乙","太古昇達","太平洋","太平洋忠孝","太平洋華園","太平洋電纜","太和","太福","文立","文源","日友","日月光","日茂","日浤","日益茂","日商栗田已停用","日理","日華","日義","日緯","木川","比用比","水流站","水美","世昕","世界先進","世益","世曜","仩宏","仩汯","冬山","北投焚化廠","卡瓦利","台一重工","台中發電廠","台化","台化麥寮","台化龍德","台北化工","台欣","台肥台中","台肥苗栗","台肥高雄","台肥新竹","台威","台耐","台朔","台康生技","台勝","台氯林園廠","台塑","台塑石化","台達化學","台電通霄","台電塔山","台電興達","台境","台聚","台橡","台糖","台鴻","台鎔科技","台耀","台灣小松","台灣月島","台灣史丹利","台灣史谷脫","台灣必成","台灣永光","台灣艾安","台灣杜邦","台灣東亞","台灣威立雅","台灣拜耳","台灣柏恩氏","台灣玻璃","台灣科信","台灣科慕","台灣茂賢","台灣栗田","台灣神隆","台灣索理思","台灣唯綠","台灣淨水","台灣陶氏","台灣菸酒內","台灣新日化","台灣電力","台灣鼎磊","台灣精技","台灣增澤","台灣德聯","台灣熱流","台灣應達","台灣應薄","台灣穗高","台灣鍊水","台灣藤澤","台灣蠟品","巨偉","巨路","巨漢","巨擘","弘旭","弘峻","弘程","弘業","弘運昇","正弘","正昌電機","正洋","正益","正隆大園廠","正隆后里","正隆竹北","正瀚生技","永大","永大明","永安","永技","永佳","永昇","永科","永罡","永祥","永裕","永嘉","永臻","永興","永龍","永豐","永豐餘竹南","永豐餘清水","永豐餘新屋","玉運","甘川","生生","田野","申豐特用應材","石化合成","禾申堡","禾帛工程","禾鈿企業社","禾覲國際","禾鎧","禾鑫豐","立","立力","立安東","立宸","立陞","立傑軸封","立督科技","立達","立榮","立衛","亙助","交通大學","仲信","兆廣","兆聯","先勝","先豐","光威","光洋","光發","光群雷射","光鋐","全省","全能","全寧企業","全澤","全興","全優","合同","合泰五金","合寬","合興石化","吉緻工程","同開","同誠","同鴻","名浦","名牌食品","向紘","宇亮","宇晟","宇貫","帆昌","年弘電機","年興紡織","成功大學","成立","成祥","成順","旭美化成","旭翔","旭豪","有福","江岱","百仕工程","百達精密","百總","竹翔","竹新","自立鐵工廠","自在水","艾律德","艾斯敦","艾瑞始達","西華飯店","亨斯邁","住華","佑奇","佑泓","佑嘉宜","佑銘","佑錦","利政","利齊","吳皓勝","呈洋","呈達","夆典","宏旭","宏奇","宏明","宏展科技","宏展實業","宏偉勝","宏連","宏遠","宏機","廷登","志升","志品","志華","志綸","李長榮林園","李長榮高雄","李長榮銅箔","杏林","杜商","沂達工程","沐宇","良乙","良進","辛吉","辰淞行","邑曾","邦圻有限","邦查","邦澤","亞太","亞世","亞世融","亞東石化","亞洲聚合","亞炬","亞通","亞翔","亞德","享展","京威","京篆","佳大","佳合興","佳妤","佳乳","佳岳","佳門","佳銘","佺茂企業","協和田","協固","協欣","協順興","和平電力","和平電機","和協工程","和勝梧棲","固鉦","固德曼","坤琳","坤霆","奇美","奇美電子","奔達","委宏","孟逸","季登","宗育","宗洋","宜晉","尚振","尚益","尚鋒工程","岱稜","幸亞","忠進","怡台","承徽","拓達","昆勇","昇陽","昇億榮","昌玹","昌桔","昌順","明山","明川","明台化工","明尼蘇達","明炫","明泰","易度","易科德","昕盛","東利榮","東沅","東昇應材","東欣","東奕","東洲","東虹","東展","東峻","東竟","東華合纖","東進","東隆五金","東聯化學","東聯光訊","松信","松喬","欣夆","欣格","欣達","油源","泓達","波沙勒斯","波頓科技","矽品","芳泉","采樾","金車","金居","金城誼","金威揚","金棠","金隆","金瑛發","金像","金鴻","金鴻龍","金瀚科技","長木","長庚","長庚大學","長庚醫院","長昇","長春人造","長春石油","長春新加坡","長野興","長榮","保仁工程","信立化學","信安","信昌林園廠","信東生技","信喜","信華","信越","信鼎","信綸","信歷台南","信歷高雄","冠仲","冠洲","冠彰","勁力幫","勁喬","南中石化","南亞光電","南亞科技","南亞麥寮(不使用)","南亞塑膠","南亞新港","南亞電路板","南亞纖維","南帝化工","南耶","南豐","品佳","品佶","品德興","城安","奕威","威誠企業行","威騰","封固","建成機械","建宏","建佳","建昱","建發","建越科技","建源","政威","春水","春碩","昱成機電","昱威","昱鑫","昶銪","柏卡","柏佶","柏興","柏營有限","柏騰","泉易","泉泰","泉業","泉業股份","泉源","泉溢","泉誠","泉興","泉興自動","泉寶","洋迅","洋甌企業","洪雨","洺江","洽麟","派博","派德","珂迪","皇基","皇璽","盈沛","盈舜","研能科技","研能觀音廠","科沛達","科冠","科晉","科基","科進","科群","紀鼎","美式自助洗","美昱","美商奇異(改瑞士商奇異)","美商福陸","美濾","美濾淨合","致品","英能","茂存","茂晉","茌原","風泰實業","風軒","香港威立雅","凌茂","原力","唐雋","展宇","展林","展聖","峪豐","峰技","峻洲","峻將","振達","挺升","晃誼","晉谷","晉瑄","晉緯","晟合","桃福","泰亦富","泰華","泰興","浤州","浦納斯","浦崴","浩瀚","海軍蘇澳","海陸","海進行","淯璽","特倡企業","珠海聯成","益裕","益鼎","秦昇","能碁","茗僑","草山水美","訊倉","財進","財團生物","陞暘","馬蘭","高抗","高治","高垣","高雄塑酯","高德","高頻","偉華","偉群","健信科技","健勝","健鼎","健鑫","唯固","啟源","國光","國洋","國科","國軍總醫院","國家奈米","國泰","國偉","國喬","國衛院","國聯矽業","寁順","寇特","崇峻","崇越","崑典","崑源","常昱楊","康呈","康淳科技","康勤","強欣","強勝","彩新","徠通","徠揚","敘祐企業","晨松","梧濟","淨合","深圳威柏","清盺","祥亞","祥昇","祥泉","祥貿","祥廣","統一","統益","翊興","貫一","通冠","連江縣","陳志賢","陳皇維","陸益","頂立","頂倫","鹿恩","麥斯特","麥寮汽電","傅鼎興","傑平","傑美利","凱士比","凱虹","凱鋒","創田","勝乙","勝仁","勝允","博威","博膜","善哉","喬東","喬泓","富士化水","富化","富津","富泰祥","富喬","富喬虎尾","富萌","富順","富農","崴鴻","復龍","惠民","揚基","揚喬","揚發","揚程","斯諾","普春","晶騰","智研","智揚","期弘","森遠","欽利","渥特","湛康","湧倫","翔暉","菩樂","華生","華邦","華亞汽電","華亞科","華河","華映","華夏海灣","華泰","華商","華捷國際","華新台中","華新電通","華新麗華","華運倉儲","華鉬","華樂士","華樂氏","詠舜","詠澤","超威","超威國際","超瑞","超達","超賢","超穩","進方","逸群","鈞能","鈞鈉","鈦城","鈦城貿易","鈦暘軸承","開中","開名電機","隆來","隆偉","雄菱","雅安","集奕","順泰","順登","順賀行","順寶電機","傳藝國際","勢豐","勤訓","匯凱","奧璐佳瑙","微邦","愛絲樂","愛德華","慈峰玻璃","新井","新弘大","新禾","新光企業","新光電機","新竹貨運","新自然","新西松","新長豐","新能","新野","新運","新電電料行","新鼎","新穩","暉峰","毓信","源寶源","溫德生","煌琦","煒盛","煜煌","瑋力","瑋昌","瑞士商奇異","瑞弘","瑞泰","瑞貿","瑞園","瑞鋒","碁富","祺峻","經緯新","經濟","經濟部","置光","群邦","群鈜","群樺","聖保祿","聖益實業","聖暉工程","聖旗","萬年清","萬里產業","萬事","萬事興","萬和","萬軍","萬泰祥","葛迪立","裔發","裕祥","裕興五金","詮泰實業","誠威","誠建","誠峰","誠開","資億","達和","達和環保","達恩科技","達高華特","達國三崎","達勝機械","達線","達磨","達闊","鈺鋒","鈺聯","鉅川","鉅倫","鉅峰","鉅鵬","鉅霸","鉅鑫","雷銫","雷德斯","鼎飛","鼎峰行","鼎勝","鼎鼎","嘉惠","嘉發","嘉新","實聯","彰永","彰德","暢懿","榮民","榮崗","榮勝機械","榮電","榮福","榮錦","榮總台北","榮總高雄","漢吉","漢辰","漢唐集成","漢桓科技","漢翔","漢華","漢碁傳動","漢磊","熊谷","碧連天","福川","福順","福聚","福聚太陽能","福樺","福懋","精峰","精湛","精華光學","維他露","維達","維德","聚熱","豪亞科技","豪昱","豪格","豪得","遠東","遠東先進","遠東新世紀","遠洋能源","遠鋒","銓士","銓正","銓程","銘昇","銘奕","銘哲","銚原","際星","億丞","億威奇","億崴","億榮","增達","寬利電機","寬亞","寬點","廣兆水電","廣承","廣欣","廣芯","德禾","德棋","德樺","德鎮盛","慶益","慶祥威","慶嶸","慶鴻","樂山","樂斯科","歐利旺","歐潁","潤泰精密","澄峰大廈","瑾柔","緯毅","膠林","蓮座山","蔚旻","衛福部","誼信","誼福","銳嶧","鋒魁","鋒霈","黎明興","憶鷹","樺棋","機生","澳商聯盛","縣城","興祥機電","錦昌","默克光電","優品","優達","擎川","擎邦","環美","環康","環球橡膠","環揚","環碩","聯成","聯沂","聯泉","聯夏","聯華氣體","聯華電子","聯超","聯穎","薛上力","謙旻","鍾昌","駿容","駿騏","鴻城","鴻傑","鴻裕","鴻禎","鴻遠","燿祥光電","燿華宜蘭","燿華電子","藍天堂","藍鯨水科技","豐丞","豐富","豐群","豐興","鎮江奇美","鎮聯科技","鎮瀛","雙城","雙詮","馥麗","懷德","瀚宇台南","瀚緯","穩合實業","藝鋒","關西農會","麒鵬","麗正","麗得","龐偉","耀文","耀樺","馨泉","霸國","顥昌","鶴美","鑫允","鑫東"]
// export let Customer_FECM=["AMPLE","CCD","CEDC","FHI","GBP菲律賓","GRANDE","LIANFA","LM","LMES","LOYAL-TEC","PHONG LE","SIEU HUYEN","TEH CHENG","一森","七福工業","九合工程","九如行","九邑","九品","九德松益","九譽","力方","力洪","力泰","力暉","力積電","力翰","力鵬","力麗","十友","三宏","三協豐","三和","三軍","三群","三嘉","三福化工","上化","上友","上林電機","上河國際","上淵","上喨","久大","久和醫療","久鈞","也順","千涵","千業","士昇","士林化技","士林紙業","大川","大中機械","大井","大允","大地酒店","大地興","大宇","大有環保","大自在","大宗","大欣","大城","大洋","大倚","大展","大桂","大將作","大康","大連","大陸工程","大陸水工","大喜","大儀","大德","大慶行","大穎","大營","大鑫","寸金","小人國","山林水","山洋","川久","川玖","工研院","中一","中化合成","中央大學","中央廣播","中石化小港","中石化頭份","中宇","中油桃煉","中油煉製","中油潤滑油","中南水電","中城","中政","中柱","中美和","中美和高雄","中國石油","中國鋼鐵","中華食品","中華紙漿","中軸","中鈞","中傳","中塑油品","中鼎","中德","中興傑達","中興電工","中鋼鋁業","中鋼機械","中龍","中聯油脂","中聯資源","中纖","丰元","五合","井盛","井新","井寶","仁吉","仁峰","今兵","介興","介鴻","允辰","元台","元利","元翎","元莆","公視","公準精密","六象","升振","及普","友正","友亦","友和","友俊","友誠","友達光電","友達桃園","友達環保","友德","友豐","天保","天泉","天倚","天祥","太乙","太古昇達","太平洋","太平洋忠孝","太平洋華園","太平洋電纜","太和","太福","文立","文源","日友","日月光","日茂","日浤","日益茂","日商栗田已停用","日理","日華","日義","日緯","木川","比用比","水流站","水美","世昕","世界先進","世益","世曜","仩宏","仩汯","冬山","北投焚化廠","卡瓦利","台一重工","台中發電廠","台化","台化麥寮","台化龍德","台北化工","台欣","台肥台中","台肥苗栗","台肥高雄","台肥新竹","台威","台耐","台朔","台康生技","台勝","台氯林園廠","台塑","台塑石化","台達化學","台電通霄","台電塔山","台電興達","台境","台聚","台橡","台糖","台鴻","台鎔科技","台耀","台灣小松","台灣月島","台灣史丹利","台灣史谷脫","台灣必成","台灣永光","台灣艾安","台灣杜邦","台灣東亞","台灣威立雅","台灣拜耳","台灣柏恩氏","台灣玻璃","台灣科信","台灣科慕","台灣茂賢","台灣栗田","台灣神隆","台灣索理思","台灣唯綠","台灣淨水","台灣陶氏","台灣菸酒內","台灣新日化","台灣電力","台灣鼎磊","台灣精技","台灣增澤","台灣德聯","台灣熱流","台灣應達","台灣應薄","台灣穗高","台灣鍊水","台灣藤澤","台灣蠟品","巨偉","巨路","巨漢","巨擘","弘旭","弘峻","弘程","弘業","弘運昇","正弘","正昌電機","正洋","正益","正隆大園廠","正隆后里","正隆竹北","正瀚生技","永大","永大明","永安","永技","永佳","永昇","永科","永罡","永祥","永裕","永嘉","永臻","永興","永龍","永豐","永豐餘竹南","永豐餘清水","永豐餘新屋","玉運","甘川","生生","田野","申豐特用應材","石化合成","禾申堡","禾帛工程","禾鈿企業社","禾覲國際","禾鎧","禾鑫豐","立","立力","立安東","立宸","立陞","立傑軸封","立督科技","立達","立榮","立衛","亙助","交通大學","仲信","兆廣","兆聯","先勝","先豐","光威","光洋","光發","光群雷射","光鋐","全省","全能","全寧企業","全澤","全興","全優","合同","合泰五金","合寬","合興石化","吉緻工程","同開","同誠","同鴻","名浦","名牌食品","向紘","宇亮","宇晟","宇貫","帆昌","年弘電機","年興紡織","成功大學","成立","成祥","成順","旭美化成","旭翔","旭豪","有福","江岱","百仕工程","百達精密","百總","竹翔","竹新","自立鐵工廠","自在水","艾律德","艾斯敦","艾瑞始達","西華飯店","亨斯邁","住華","佑奇","佑泓","佑嘉宜","佑銘","佑錦","利政","利齊","吳皓勝","呈洋","呈達","夆典","宏旭","宏奇","宏明","宏展科技","宏展實業","宏偉勝","宏連","宏遠","宏機","廷登","志升","志品","志華","志綸","李長榮林園","李長榮高雄","李長榮銅箔","杏林","杜商","沂達工程","沐宇","良乙","良進","辛吉","辰淞行","邑曾","邦圻有限","邦查","邦澤","亞太","亞世","亞世融","亞東石化","亞洲聚合","亞炬","亞通","亞翔","亞德","享展","京威","京篆","佳大","佳合興","佳妤","佳乳","佳岳","佳門","佳銘","佺茂企業","協和田","協固","協欣","協順興","和平電力","和平電機","和協工程","和勝梧棲","固鉦","固德曼","坤琳","坤霆","奇美","奇美電子","奔達","委宏","孟逸","季登","宗育","宗洋","宜晉","尚振","尚益","尚鋒工程","岱稜","幸亞","忠進","怡台","承徽","拓達","昆勇","昇陽","昇億榮","昌玹","昌桔","昌順","明山","明川","明台化工","明尼蘇達","明炫","明泰","易度","易科德","昕盛","東利榮","東沅","東昇應材","東欣","東奕","東洲","東虹","東展","東峻","東竟","東華合纖","東進","東隆五金","東聯化學","東聯光訊","松信","松喬","欣夆","欣格","欣達","油源","泓達","波沙勒斯","波頓科技","矽品","芳泉","采樾","金車","金居","金城誼","金威揚","金棠","金隆","金瑛發","金像","金鴻","金鴻龍","金瀚科技","長木","長庚","長庚大學","長庚醫院","長昇","長春人造","長春石油","長春新加坡","長野興","長榮","保仁工程","信立化學","信安","信昌林園廠","信東生技","信喜","信華","信越","信鼎","信綸","信歷台南","信歷高雄","冠仲","冠洲","冠彰","勁力幫","勁喬","南中石化","南亞光電","南亞科技","南亞麥寮(不使用)","南亞塑膠","南亞新港","南亞電路板","南亞纖維","南帝化工","南耶","南豐","品佳","品佶","品德興","城安","奕威","威誠企業行","威騰","封固","建成機械","建宏","建佳","建昱","建發","建越科技","建源","政威","春水","春碩","昱成機電","昱威","昱鑫","昶銪","柏卡","柏佶","柏興","柏營有限","柏騰","泉易","泉泰","泉業","泉業股份","泉源","泉溢","泉誠","泉興","泉興自動","泉寶","洋迅","洋甌企業","洪雨","洺江","洽麟","派博","派德","珂迪","皇基","皇璽","盈沛","盈舜","研能科技","研能觀音廠","科沛達","科冠","科晉","科基","科進","科群","紀鼎","美式自助洗","美昱","美商奇異(改瑞士商奇異)","美商福陸","美濾","美濾淨合","致品","英能","茂存","茂晉","茌原","風泰實業","風軒","香港威立雅","凌茂","原力","唐雋","展宇","展林","展聖","峪豐","峰技","峻洲","峻將","振達","挺升","晃誼","晉谷","晉瑄","晉緯","晟合","桃福","泰亦富","泰華","泰興","浤州","浦納斯","浦崴","浩瀚","海軍蘇澳","海陸","海進行","淯璽","特倡企業","珠海聯成","益裕","益鼎","秦昇","能碁","茗僑","草山水美","訊倉","財進","財團生物","陞暘","馬蘭","高抗","高治","高垣","高雄塑酯","高德","高頻","偉華","偉群","健信科技","健勝","健鼎","健鑫","唯固","啟源","國光","國洋","國科","國軍總醫院","國家奈米","國泰","國偉","國喬","國衛院","國聯矽業","寁順","寇特","崇峻","崇越","崑典","崑源","常昱楊","康呈","康淳科技","康勤","強欣","強勝","彩新","徠通","徠揚","敘祐企業","晨松","梧濟","淨合","深圳威柏","清盺","祥亞","祥昇","祥泉","祥貿","祥廣","統一","統益","翊興","貫一","通冠","連江縣","陳志賢","陳皇維","陸益","頂立","頂倫","鹿恩","麥斯特","麥寮汽電","傅鼎興","傑平","傑美利","凱士比","凱虹","凱鋒","創田","勝乙","勝仁","勝允","博威","博膜","善哉","喬東","喬泓","富士化水","富化","富津","富泰祥","富喬","富喬虎尾","富萌","富順","富農","崴鴻","復龍","惠民","揚基","揚喬","揚發","揚程","斯諾","普春","晶騰","智研","智揚","期弘","森遠","欽利","渥特","湛康","湧倫","翔暉","菩樂","華生","華邦","華亞汽電","華亞科","華河","華映","華夏海灣","華泰","華商","華捷國際","華新台中","華新電通","華新麗華","華運倉儲","華鉬","華樂士","華樂氏","詠舜","詠澤","超威","超威國際","超瑞","超達","超賢","超穩","進方","逸群","鈞能","鈞鈉","鈦城","鈦城貿易","鈦暘軸承","開中","開名電機","隆來","隆偉","雄菱","雅安","集奕","順泰","順登","順賀行","順寶電機","傳藝國際","勢豐","勤訓","匯凱","奧璐佳瑙","微邦","愛絲樂","愛德華","慈峰玻璃","新井","新弘大","新禾","新光企業","新光電機","新竹貨運","新自然","新西松","新長豐","新能","新野","新運","新電電料行","新鼎","新穩","暉峰","毓信","源寶源","溫德生","煌琦","煒盛","煜煌","瑋力","瑋昌","瑞士商奇異","瑞弘","瑞泰","瑞貿","瑞園","瑞鋒","碁富","祺峻","經緯新","經濟","經濟部","置光","群邦","群鈜","群樺","聖保祿","聖益實業","聖暉工程","聖旗","萬年清","萬里產業","萬事","萬事興","萬和","萬軍","萬泰祥","葛迪立","裔發","裕祥","裕興五金","詮泰實業","誠威","誠建","誠峰","誠開","資億","達和","達和環保","達恩科技","達高華特","達國三崎","達勝機械","達線","達磨","達闊","鈺鋒","鈺聯","鉅川","鉅倫","鉅峰","鉅鵬","鉅霸","鉅鑫","雷銫","雷德斯","鼎飛","鼎峰行","鼎勝","鼎鼎","嘉惠","嘉發","嘉新","實聯","彰永","彰德","暢懿","榮民","榮崗","榮勝機械","榮電","榮福","榮錦","榮總台北","榮總高雄","漢吉","漢辰","漢唐集成","漢桓科技","漢翔","漢華","漢碁傳動","漢磊","熊谷","碧連天","福川","福順","福聚","福聚太陽能","福樺","福懋","精峰","精湛","精華光學","維他露","維達","維德","聚熱","豪亞科技","豪昱","豪格","豪得","遠東","遠東先進","遠東新世紀","遠洋能源","遠鋒","銓士","銓正","銓程","銘昇","銘奕","銘哲","銚原","際星","億丞","億威奇","億崴","億榮","增達","寬利電機","寬亞","寬點","廣兆水電","廣承","廣欣","廣芯","德禾","德棋","德樺","德鎮盛","慶益","慶祥威","慶嶸","慶鴻","樂山","樂斯科","歐利旺","歐潁","潤泰精密","澄峰大廈","瑾柔","緯毅","膠林","蓮座山","蔚旻","衛福部","誼信","誼福","銳嶧","鋒魁","鋒霈","黎明興","憶鷹","樺棋","機生","澳商聯盛","縣城","興祥機電","錦昌","默克光電","優品","優達","擎川","擎邦","環美","環康","環球橡膠","環揚","環碩","聯成","聯沂","聯泉","聯夏","聯華氣體","聯華電子","聯超","聯穎","薛上力","謙旻","鍾昌","駿容","駿騏","鴻城","鴻傑","鴻裕","鴻禎","鴻遠","燿祥光電","燿華宜蘭","燿華電子","藍天堂","藍鯨水科技","豐丞","豐富","豐群","豐興","鎮江奇美","鎮聯科技","鎮瀛","雙城","雙詮","馥麗","懷德","瀚宇台南","瀚緯","穩合實業","藝鋒","關西農會","麒鵬","麗正","麗得","龐偉","耀文","耀樺","馨泉","霸國","顥昌","鶴美","鑫允","鑫東"]
// export let Customer_GPW=["1-AE","1-AN","1-C4","1-ECH","1-EVA","1-HDPE","1-IEM","1-MMA","1-POM / SAP","1-PVC","1-VCM","1-仁武","1-仁武HCFC","1-仁武IEM","1-仁武PE","1-仁武PVC","1-仁武VCM","1-仁武公用廠","1-仁武台麗朗","1-林園","1-林園AE","1-林園IEM","1-林園PE","1-林園PP","1-林園PVC","1-林園VCM","1-保一廠","1-新港","2-BPA","2-EG","2-EPOXY","2-MA","2-丁二醇1.4BG","2-麥寮","2-新港","2-樹林/工三","2-蘆竹錦興","4-ARO","4-PC","4-Phenol","4-PP / ABS / PS","4-PTA","4-SM","4-新港","4-龍德","6-C5","6-LBO","6-OL","6-工務部","6-公用廠","6-汽電","6-基礎油","6-煉二課","6-煉油廠","6-彰濱油庫","6-儲運站-台北","6-儲運站-桃園","LOYAL MOTION","LOYAL TEC 越南","OTHERS","QH-科騰","RA-南中石化","RT-華亞汽電","RV-台灣醋酸","TR-麥電","TU-中塑油品","XU-台灣必成","大洋塑膠","大連-大社","大連-大發","大連-馬來西亞","大連-麥寮","大提企業","山雄","中大興","中石化-大社","中石化-小港","中石化-頭份","中油-大林","中油-台中","中油-林園","中油-溪洲回收場","中油-嘉義","中美和-台中","中華映管","中華紙漿","中鼎","中興電工","中鋼","中鋼碳素","中鋼鋁","中聯油脂","中纖","仁富","及泉機械","台肥-台中","台肥-高雄","台電-大甲溪發電廠","台電-塔山電廠","台糖-小港","台灣巴斯夫","台灣石化合成","台灣石化合成(台合科技)","台灣石化合成(合興石化)","台灣汽電共生","台灣科思創","台灣科慕","台灣苯乙烯","台灣朗盛","台灣神隆","台灣索理思","台灣康寧","台灣強克","台灣陶氏","台灣凱優","台灣氯乙烯","台灣開利","台灣聚合","台灣橡膠","巨偉","正隆","申豐特用","先勝","光泉牧場","竹成","自立鐵工廠","李長榮-大社","李長榮-林園","李長榮-高雄","亞東石化","亞洲聚合","和協環保(和協工程)","奇美","尚承鋼鐵","明園工程","朋億","東聯化學","泓達化工","肯幫","金居開發","金豪日","長春人造-大發","長春人造-麥寮","長春-大社","長春石化-苗栗","長春石化-麥寮","長連-SINGAPORE","長興材料","昱威","高治-台北廠","高治-屏東廠","高治-褒忠廠","高德","高豐","高豐五金","偉福","商美安","國基冷凍","國喬石化","國聯矽業","傑笙","博桉生物","富百","景馨機械","港埠保養廠","竣宏五金","菖億","華夏海灣","匯能科技","新加坡商羅聖","瑞士商奇異","聖鐘","達和環保","鈺發","鈺德聯合","鈺鋒 1部","鈺鋒 2部","鼎立金屬","榮福","漢珈","福懋興業","履濠","碼槽","磐亞","燁聯鋼鐵","環球油漆","環球橡膠","聯成化學","聯沂/力方","聯發","聯華氣體","聯超實業","聯新","寶德能源","騰森機械"]

/*eslint-disable */
let Customer_GPK1=[]
let Customer_GPK2=[]
let Customer_FECN=[]
let Customer_FECM=[]
let Customer_GPW=[]

export const GridColumnWidth_Image="90px";
export const GridColumnWidth_Image_M=90;
export const GridColumnWidth_Name="200px";
export const GridColumnWidth_Name_M=200;
export const GridColumnWidth_Money="130px";
export const GridColumnWidth_Money_M=130;
export default {

}
